import type { FaireProductEntity } from "../../entity_types/product";

export const p_xqcwustfnr: FaireProductEntity = {
  token: "p_xqcwustfnr",
  type: "product",
  name: "University of Arkansas HOGS Charm Necklace Arkansas Gameday",
  brandToken: "b_af92w55rjq",
  brandName: "Steele Sloan Designs",
  imageUrl: "https://cdn.faire.com/fastly/bf5ab85ea2302cd163dcfd619dc56cd496c9ace6c8af4a79a4ad8f8257abf8b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab14e6c1636e9fe6b2d0608635f48849753329166226e7b2d4fdf173810d95ec.jpeg"
  ],
  priceDollars: 30.49,
  description: "Go Hogs! HOGS Charm Necklace- Gold HOGS Dangle Layer Necklace perfect for all University of Arkansas Fans Tarnish Resistant Stainless Steel Officially Licensed\n\nThe PERFECT necklace for University of Arkansas Fans - HOGS Charm Necklace, with HOGS dangles on necklace perfect to layer or wear on it's own - Tarnish resistant gold stainless steel will add to making this a favorite for all HOGS fans and makes the PERFECT gift for Hogs Fans!   15 1/2 inch length with 2 inch extension. This is an officially licensed product",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:42.551Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
